import React from 'react';

const arrowRenderer = (before, after) => {
  if (before && after) {
    return (
      <>
        {before} &#8594; {after}
      </>
    );
  }

  return <>{before || after}</>;
};

export default arrowRenderer;
